import { DataProvider } from "../helpers"

import { Enums } from "../models/common/enums"
import { OpData, OpDevice, OpDeviceHierarchy, OpDescr } from "../models/core"
import { OpActionResult } from "../models/custom"
import { ColumnInfo } from "../models/custom/column-info"
import * as _ from 'underscore'

export class DataProviderDescription {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End

    // Public Methods

    public saveDescriptions = (opObj: OpDescr[]): JQueryPromise<OpDescr[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveDescriptions', { ToBeSaved: opObj.map((obj: OpDescr) => obj.toJSON()), Module: Enums.Module.WebSIMAX }, 'OpxSaveDescriptionsResult')
            .then((data: any[]) => {
                if (_.size(data) > 0) {
                    return data.map((d: any) => {
                        return new OpDescr(d)
                    })
                }

                return [];
            })
    }

    // Public Methods End
}
